import UseCases from './UseCases';

const UseCasesConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/casos-de-uso',
            component: UseCases
        }
    ]
};

export default UseCasesConfig;
